// @generated by protoc-gen-es v2.9.0 with parameter "import_extension=js"
// @generated from file services/ontology/api/artifact.proto (package gx.ontology.api, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_services_ontology_resources_artifact } from "../resources/artifact_pb.js";
import { file_shared_pagination } from "../../../shared/pagination_pb.js";
import { file_shared_sorting } from "../../../shared/sorting_pb.js";

/**
 * Describes the file services/ontology/api/artifact.proto.
 */
export const file_services_ontology_api_artifact = /*@__PURE__*/
  fileDesc("CiRzZXJ2aWNlcy9vbnRvbG9neS9hcGkvYXJ0aWZhY3QucHJvdG8SD2d4Lm9udG9sb2d5LmFwaSIpChJHZXRBcnRpZmFjdFJlcXVlc3QSEwoLYXJ0aWZhY3RfaWQYASABKAkiVwoTR2V0QXJ0aWZhY3RSZXNwb25zZRJACghhcnRpZmFjdBgBIAEoCzIuLmd4Lm9udG9sb2d5LnJlc291cmNlcy5Qcm9qZWN0QXJ0aWZhY3RSZXNvdXJjZSKIAQoUTGlzdEFydGlmYWN0c1JlcXVlc3QSEgoKcHJvamVjdF9pZBgBIAEoCRIwCgpwYWdpbmF0aW9uGAIgASgLMhwuZ3guc2hhcmVkLlBhZ2luYXRpb25SZXF1ZXN0EioKB3NvcnRpbmcYAyABKAsyGS5neC5zaGFyZWQuU29ydGluZ1JlcXVlc3QijQEKFUxpc3RBcnRpZmFjdHNSZXNwb25zZRJBCglhcnRpZmFjdHMYASADKAsyLi5neC5vbnRvbG9neS5yZXNvdXJjZXMuUHJvamVjdEFydGlmYWN0UmVzb3VyY2USMQoKcGFnaW5hdGlvbhgCIAEoCzIdLmd4LnNoYXJlZC5QYWdpbmF0aW9uUmVzcG9uc2UiNQodR2V0QXJ0aWZhY3REb3dubG9hZFVybFJlcXVlc3QSFAoMYXJ0aWZhY3RfdXJpGAEgASgJIi0KHkdldEFydGlmYWN0RG93bmxvYWRVcmxSZXNwb25zZRILCgN1cmwYASABKAkyxgIKD0FydGlmYWN0U2VydmljZRJYCgtHZXRBcnRpZmFjdBIjLmd4Lm9udG9sb2d5LmFwaS5HZXRBcnRpZmFjdFJlcXVlc3QaJC5neC5vbnRvbG9neS5hcGkuR2V0QXJ0aWZhY3RSZXNwb25zZRJeCg1MaXN0QXJ0aWZhY3RzEiUuZ3gub250b2xvZ3kuYXBpLkxpc3RBcnRpZmFjdHNSZXF1ZXN0GiYuZ3gub250b2xvZ3kuYXBpLkxpc3RBcnRpZmFjdHNSZXNwb25zZRJ5ChZHZXRBcnRpZmFjdERvd25sb2FkVXJsEi4uZ3gub250b2xvZ3kuYXBpLkdldEFydGlmYWN0RG93bmxvYWRVcmxSZXF1ZXN0Gi8uZ3gub250b2xvZ3kuYXBpLkdldEFydGlmYWN0RG93bmxvYWRVcmxSZXNwb25zZULFAQoTY29tLmd4Lm9udG9sb2d5LmFwaUINQXJ0aWZhY3RQcm90b1ABWkFnaXRodWIuY29tL2dhbGF4eS1pby9neC9zaGFyZWQvZ28vY29udHJhY3RzL3NlcnZpY2VzL29udG9sb2d5L2FwaaICA0dPQaoCD0d4Lk9udG9sb2d5LkFwacoCD0d4XE9udG9sb2d5XEFwaeICG0d4XE9udG9sb2d5XEFwaVxHUEJNZXRhZGF0YeoCEUd4OjpPbnRvbG9neTo6QXBpYgZwcm90bzM", [file_services_ontology_resources_artifact, file_shared_pagination, file_shared_sorting]);

/**
 * Describes the message gx.ontology.api.GetArtifactRequest.
 * Use `create(GetArtifactRequestSchema)` to create a new message.
 */
export const GetArtifactRequestSchema = /*@__PURE__*/
  messageDesc(file_services_ontology_api_artifact, 0);

/**
 * Describes the message gx.ontology.api.GetArtifactResponse.
 * Use `create(GetArtifactResponseSchema)` to create a new message.
 */
export const GetArtifactResponseSchema = /*@__PURE__*/
  messageDesc(file_services_ontology_api_artifact, 1);

/**
 * Describes the message gx.ontology.api.ListArtifactsRequest.
 * Use `create(ListArtifactsRequestSchema)` to create a new message.
 */
export const ListArtifactsRequestSchema = /*@__PURE__*/
  messageDesc(file_services_ontology_api_artifact, 2);

/**
 * Describes the message gx.ontology.api.ListArtifactsResponse.
 * Use `create(ListArtifactsResponseSchema)` to create a new message.
 */
export const ListArtifactsResponseSchema = /*@__PURE__*/
  messageDesc(file_services_ontology_api_artifact, 3);

/**
 * Describes the message gx.ontology.api.GetArtifactDownloadUrlRequest.
 * Use `create(GetArtifactDownloadUrlRequestSchema)` to create a new message.
 */
export const GetArtifactDownloadUrlRequestSchema = /*@__PURE__*/
  messageDesc(file_services_ontology_api_artifact, 4);

/**
 * Describes the message gx.ontology.api.GetArtifactDownloadUrlResponse.
 * Use `create(GetArtifactDownloadUrlResponseSchema)` to create a new message.
 */
export const GetArtifactDownloadUrlResponseSchema = /*@__PURE__*/
  messageDesc(file_services_ontology_api_artifact, 5);

/**
 * @generated from service gx.ontology.api.ArtifactService
 */
export const ArtifactService = /*@__PURE__*/
  serviceDesc(file_services_ontology_api_artifact, 0);

